export var checkAllConditionTrue = function checkAllConditionTrue() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.every(arg => arg);
};
export var checkAnyConditionTrue = function checkAnyConditionTrue() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return args.some(arg => arg);
};
export var checkIfAnyProviderCountIsNull = providerDetails => {
  return providerDetails.some(provider => (provider === null || provider === void 0 ? void 0 : provider.count) === null);
};
export var getTotalSelectedSimCount = (providerDetails, index) => {
  var simCount = providerDetails.reduce((acc, provider, i) => {
    if (i !== index) {
      acc += provider.count;
    }
    return acc;
  }, 0);
  return simCount;
};
export var generateDropdownDataWithNumber = function generateDropdownDataWithNumber(length, start) {
  if (start === void 0) {
    start = 0;
  }
  return Array.from({
    length
  }, (_, index) => {
    var value = "" + (index + start);
    return {
      value,
      subHeading: value
    };
  });
};
export var generateSimProviderDropDownList = (dropDownList, providerDetails) => {
  var providers = providerDetails.reduce((acc, item) => {
    var count = item.count,
      provider = item.provider;
    acc[provider] = count;
    return acc;
  }, {});
  return dropDownList.filter(_ref => {
    var value = _ref.value;
    return providers[value] === undefined;
  });
};
export var numberOfUnSelectedProviders = (providerName, providerDetails) => {
  var selectedProvidersSet = new Set(providerDetails.map(provider => provider.provider));
  var unSelectedProvidersName = providerName.dropdownList.filter(item => !selectedProvidersSet.has(item.value)).map(item => item.value);
  return unSelectedProvidersName.length;
};